import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CustomerCampaignBuyersPage } from '@/features/customer/pages/campaign-buyers'
import {
  assignmentListParamsToRecord,
  assignmentListSearchFromRecord,
  type AssignmentListParams,
} from '@/lib/campaignBuyerList'
import { assignmentListRouteSearchSchema } from '@/features/shared/campaign-targets/lib/assignment-list-route-search'

export const Route = createFileRoute('/_authenticated/customer/campaign-targets')({
  validateSearch: z.object({
    campaign_id: z.string().optional(),
    ...assignmentListRouteSearchSchema,
  }),
  component: CustomerCampaignTargetsRoute,
})

function CustomerCampaignTargetsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const listParams = assignmentListSearchFromRecord(search)

  const onListParamsChange = (next: AssignmentListParams) => {
    void navigate({
      search: {
        campaign_id: search.campaign_id,
        ...assignmentListParamsToRecord(next),
      },
      replace: true,
    })
  }

  const onCampaignIdChange = (next?: string) => {
    void navigate({
      search: {
        campaign_id: next,
        ...assignmentListParamsToRecord({}),
      },
      replace: true,
    })
  }

  return (
    <CustomerCampaignBuyersPage
      campaignId={search.campaign_id}
      listParams={listParams}
      onListParamsChange={onListParamsChange}
      onCampaignIdChange={onCampaignIdChange}
    />
  )
}
